// extracted by mini-css-extract-plugin
export var container = "_2t-0";
export var icon = "_2t-1";